var f = require('float')

module.exports = function(n) {
    return f.round(n, 6)
}
